module.exports = __webpack_public_path__ + "static/media/refresh.08e64074.svg";